import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchTopPicksProductsAPI } from "./topPicksAPI";

export const fetchTopPicksProductsData = createAsyncThunk(
    "product/fetchTopPicksProductsData",
    async () => {
        const data = await fetchTopPicksProductsAPI();
        return data
    }
)

const topPicksSlice = createSlice({
    name: "topPicksproducts",
    initialState: {
        topPicksproducts: [],
        loading: false,
        error: null
    },

    reducers: {},

    extraReducers: (builder) => {
        builder
        .addCase(fetchTopPicksProductsData.pending, (state) => {
            state.loading = true;
        })
        .addCase(fetchTopPicksProductsData.fulfilled, (state, action) => {
            state.loading = false;
            state.topPicksproducts = action.payload.top_picks || [];
        })
        .addCase(fetchTopPicksProductsData.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        })
    }
})

export default topPicksSlice.reducer;